export default "__VITE_ASSET__d178f618__"